import { Box, Typography } from "@mui/material";

const PDFLoader = ({ loading = false, message = "Generating PDF..." }) => {
  if (!loading) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(0, 0, 0, 0.3)",
        backdropFilter: "blur(2px)",
        zIndex: 10,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            border: "3px solid rgba(255, 255, 255, 0.3)",
            borderTop: "3px solid white",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            "@keyframes spin": {
              to: { transform: "rotate(360deg)" },
            },
          }}
        />
        <Typography sx={{ color: "white", fontSize: "12px" }}>
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

export default PDFLoader;
